import React from "react";

import styled from "styled-components/macro";

import flocknoteStateHooks from "Flocknote/stateHooks";

import familyRegStateHooks from "Signups/FamilyRegistration/stateHooks";

import FnrLabeledIcon from "UI/FnrLabeledIcon/FnrLabeledIcon";
import FnrTappyShrink from "UI/FnrTappyShrink/FnrTappyShrink";

export default function ManageProfileFields() {
  const [groupId] = familyRegStateHooks.useEveryoneGroupID();
  const fetchAdminSettings = familyRegStateHooks.useFetchAdminSettings();
  const [, { openModal }] = flocknoteStateHooks.useModal();

  const handleOpen = () => {
    openModal("ExtendedFields", { groupId, onClose: fetchAdminSettings });
  };

  return (
    <SFnrTappyShrink
      onClick={handleOpen}
      elementType="button"
      data-cy="manageProfileFieldsBtn"
    >
      <FnrLabeledIcon
        icon="fa-clipboard-list far"
        data-cy="ManageProfileFields_LabeledIcon"
        variant="disabled"
      >
        Manage profile fields
      </FnrLabeledIcon>
    </SFnrTappyShrink>
  );
}

const SFnrTappyShrink = styled(FnrTappyShrink)`
  width: 100%;
  margin-top: 8px;
  padding-bottom: 4px;
`;
